module.exports = __webpack_public_path__ + "static/media/fly0116.7b090b51.webp";